module.exports = __webpack_public_path__ + "static/media/reedUi909Favicon.38b20f13.ico";